import { Breadcrumb, Image } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../components";
import success from "./icons/success.png";
import styles from "./style.module.scss";

const ModifySuccess = () => {
  const { t } = useTranslation();
  const [successful, setSuccess] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.breadCrumb}>
        <Breadcrumb
          separator=">"
          items={[
            {
              title: t("normal.forgotPassword"),
            },
            {
              title: t("forgotPassword.enterEmail.page"),
            },
            {
              title: t("normal.complete"),
            },
          ]}
        />
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.successText}>
          <div>{t("normal.editSuccess")}</div>
        </div>
        <Image
          src={success}
          preview={false}
          style={{ width: "186px", height: "auto" }}
        />
        <CustomButton
          type="primary"
          onClick={() => {
            navigate("/signin");
          }}
        >
          {t("normal.goSignin")}
        </CustomButton>
      </div>
    </>
  );
};

export default ModifySuccess;
